module.exports = __webpack_public_path__ + "img/business-solutions-card1.a27dba52.png";